<p-popover
  class=""
  #opHelp
  [dt]="{ overlayArrowOffset: '100%' }"
  [styleClass]="'popover--no-arrow popover--ml-15px'"
>
  <div class="flex flex-row gap-2 w-[25rem] items-center">
    <input
      pInputText
      id="environment-createdat"
      [(ngModel)]="currentUrl"
      [class.ng-invalid]="isInvalidUrl()"
      class="flex-1"
    />

    <p-button
      (onClick)="goToUrl()"
      [disabled]="isInvalidUrl()"
      icon="pi pi-external-link"
    />
    <p-button
      (onClick)="saveUrl()"
      [disabled]="isInvalidUrl()"
      icon="pi pi-save"
    />
    <p-button
      [severity]="'danger'"
      icon="pi pi-trash"
      (onClick)="deleteUrl()"
    />
  </div>
</p-popover>
<p-button
  severity="secondary"
  outlined
  (click)="isAdmin ? opHelp.toggle($event) : goToUrl()"
  class="overflow-visible"
  [pTooltip]="currentUrl"
  tooltipPosition="left"
>
  <i class="pi pi-question-circle"></i>
</p-button>
